import React from "react";
import { ScenarioElement } from "../../../../model/playerConfiguration/ScenarioElement";
import { PastOrCurrentPart } from "../../../../model/scenarioPath/PastOrCurrentPart";

import "@styles/c-part.scss";

interface Props {
  className?: string;
  part: PastOrCurrentPart;
  onPartClicked: (scenarioElement: ScenarioElement, progress: number) => void;
  onMouseMove?: (event: React.MouseEvent) => void;
  onMouseLeave?: () => void;
}

interface State {}

/**
 * This component represents a seekbar's future or past segment.
 */
export class PartComponent extends React.Component<Props, State> {
  private html: HTMLDivElement;

  render() {
    const { className, part, onMouseMove, onMouseLeave } = this.props;
    return (
      <div
        className={`c-part ${className || ""}`}
        style={{
          flexBasis: `${part.size}%`,
        }}
        ref={(element) => (this.html = element)}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        onClick={(event) => this.handlePartClicked(event)}
      >
        <div className="c-part__bar" />
      </div>
    );
  }

  private handlePartClicked(event: React.MouseEvent) {
    const { part, onPartClicked } = this.props;

    if (part.scenarioElement) {
      const partBoundingRect = this.html.getBoundingClientRect();

      const progress = (event.clientX - partBoundingRect.left) / (partBoundingRect.right - partBoundingRect.left);
      onPartClicked(part.scenarioElement, progress);
    }
  }
}
